import camelCase from 'lodash-es/camelCase';
import cloneDeep from 'lodash-es/cloneDeep';
import isBoolean from 'lodash-es/isBoolean';
import isNull from 'lodash-es/isNull';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';
import snakeCase from 'lodash-es/snakeCase';

export default class JSONTransform {
  constructor(data) {
    const clonedData = cloneDeep(data);

    this.toCamelCaseKeys = () => this.transformJSONKeys(clonedData, camelCase);
    this.toSnakeCaseKeys = () => this.transformJSONKeys(clonedData, snakeCase);
  }

  transformJSONKeys(data, targetCaseFn) {
    if (Array.isArray(data)) {
      data.map((obj) => this.transformObjKeys(obj, targetCaseFn));
    } else if (isObject(data)) {
      this.transformObjKeys(data, targetCaseFn);
    }

    return data;
  }

  transformObjKeys(obj, targetCaseFn) {
    if (isBoolean(obj) || isNumber(obj) || isNull(obj) || isString(obj)) {
      return obj;
    } else {
      Object.keys(obj).forEach((key) => {
        // lodash/snakeCase gets this prefix and transforms into 's_2_s' instead of 's2s',
        // which is causing some issues in our API integratioins
        // Replace 's_2_s' to 's2s' avoids issue, independent of the case transformation
        const newKey = targetCaseFn(key).replace('s_2_s', 's2s');
        obj[newKey] = obj[key];

        if (newKey !== key) {
          delete obj[key];
        }

        if (Array.isArray(obj[newKey])) {
          obj[newKey].map((_obj) => this.transformObjKeys(_obj, targetCaseFn));
        } else if (isObject(obj[newKey])) {
          this.transformObjKeys(obj[newKey], targetCaseFn);
        }
      });
    }
  }
}
